<template>
    <form-modal
        :id="id"
        :ref="id"

        :placeholder-button="tituloBotao" 

        :fields="colunasMutaveis"
        :values="dadosMutaveis"

        @ok="$emit('ok', $event)"
        @cancel="$emit('cancel', $event)"
        @edit="$emit('editar', $event, true)"
        @remove="$emit('remover', $event, true)"

        :titleModal="tituloModal"

        :create="criar"
        :read="ler"
        :update="atualizar"
        :remove="remover"
        :controles="controles"
        hide-button

        :ok-cancel="botaoOkViraCancelar"
        :somente-ok="somenteOk"

        :accordion-title="tituloTabelaMutavel"
    >
        <template #title><slot name="titulo-modal">{{tituloModal}}</slot></template>
        <template #after-button>
            <b-button variant="success" @click="baixarComprovantes" class="ml-2" size="sm">
                <i class="fas fa-cloud-download mr-2"></i>
                Baixar comprovantes
            </b-button>
        </template>
        <template #table>
            <div v-if="esconderRealizado"></div>
        </template>
        <template #beforeTable>
            <accordion
                :id="`${id}-1`" 
                :title="tituloTabelaImutavel"
                sub
                :accordion="id"
                visible
            >
                <template #append-title>
                    <div>
                        <b-button  class="ml-2" v-if="esconderRealizado && criar" variant="info" size="sm" @click="openModalPrevisto">
                            <i class="fa-solid fa-plus mr-1"></i>
                            {{tituloBotaoPrevisto}}
                        </b-button>
                        
                    </div>
                </template>
                
                <div class="p-3">
                    <b-table head-variant="dark" hover :items="dadosImutaveis" :fields="colunasImutaveis">
                        <template v-slot:[`cell(${colunaImagem})`]="data">
                            <b-avatar  :src="data.value"></b-avatar>
                        </template>
                        <template  #cell(actions)="data">
                            <div class="d-flex">
                                <slot name="buttons" v-bind:data="data">
                                    <slot name="buttons-prepend" v-bind:data="data.item"></slot>
                                    <b-button variant="flat-primary" v-if="esconderRealizado && atualizar" class="mr-2" @click="$emit('editar', data.item, false)"><i class="fas fa-edit"></i></b-button>
                                    <b-button variant="flat-danger" v-if="esconderRealizado && remover" class="mr-2" @click="$emit('remover', data.item, false)"><i class="fas fa-trash"></i></b-button>
                                    <slot name="buttons-append" v-bind:data="data.item"></slot>
                                </slot>
                            </div>
                        </template>
                    </b-table>
                </div>
            </accordion>
            
        </template>
        <template #modal>
            <slot name="modal"></slot>
        </template>
    </form-modal>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import Accordion from '@/components/card/Accordion';
export default {
    name: "FormModalPersonalizado",
    components: {
        FormModal,
        Accordion
    },
    props : {
        id : {
            type: String,
            required: true
        },
        tituloBotao : {
            type: String,
            default: "Inserir"
        },
        tituloModal : {
            type: String,
            default: ""
        },
        tituloTabelaMutavel : {
            type: String,
            default: ""
        },
        colunasMutaveis : {
            type: Array,
            default: () => [],
        },
        dadosMutaveis : {
            type: Array,
            default: () => []
        },
        colunaImagem : {
            type: String,
            default: null
        },

        controles : {
            type: Boolean,
            default: false
        },
        tituloTabelaImutavel : {
            type: String,
            default: ""
        },
        colunasImutaveis : {
            type: Array,
            default: () => []
        },
        dadosImutaveis : {
            type: Array,
            default: () => []
        },
        criar : {
            type: Boolean,
            default: false
        },
        ler : {
            type: Boolean,
            default: false
        },
        atualizar : {
            type: Boolean,
            default: false
        },
        remover : {
            type: Boolean,
            default: false
        },
        tituloBotaoPrevisto : {
            type: String,
            default: "Inserir"
        },

        esconderRealizado : {
            type: Boolean,
            default: true
        },

        botaoOkViraCancelar : {
            type: Boolean,
            default: false
        },

        somenteOk : {
            type: Boolean,
            default: false
        }
    },
    methods : {
        openModal :  function(){
            this.$refs[this.id].openModal();
            this.$emit('abriuRealizado', true);
        },
        openModalPrevisto : function(e){
            e.stopPropagation();
            this.$refs[this.id].openModal();
            this.$emit('abriuRealizado', false);
        },

        closeModal : function(){
            this.$refs[this.id].closeModal();
        },
        baixarComprovantes : function(e){
            e.stopPropagation();
            this.$emit('baixarComprovantes');
        }
    }
}
</script>
<style lang="">
    
</style>